module.exports = __webpack_public_path__ + "img/search-gray.9af6d6f8.svg";